import React, { /*useState, */useMemo } from "react";
import FieldInputSelect from "components/FieldInputSelect";
import TimeZones, { selectedZone/*, offset*/ } from "constants/Timezones";
import { HDatums, VDatums } from "constants/common";
import * as Yup from "yup";
import BaseForm from "./BaseForm";

const FormCoordinates = () => {
  const schema = Yup.object().shape({
    timezone: Yup.string().required().label("Time Zone"),
    hdatum: Yup.string().required().label("Horizontal Datum").default('wgs84'),
    vdatum: Yup.string().required().label("Vertical Datum").default('wgs84')
  })
  /*const [timeZone, setTimeZone] = useState('');*/
  const selectedHDatum = "wgs84";
  const selectedVDatum = "wgs84";

  const TimeZonesData = useMemo(() => TimeZones.map((zone: any) => {
    const { text:label, value, offset:timeZoneOffset} = zone;

    /*(typeof selectedZone === 'undefined' || selectedZone === value) &&
            offset === parseInt(timeZoneOffset) && setTimeZone(value);*/

    return {
      label,
      value
    }
  }), [TimeZones, selectedZone]);

  const HDatumsData = useMemo(() => HDatums.map((entry: any) => {
    const { text:label, value} = entry;
    return {
      label,
      value
    }
  }), [HDatums]);

  const VDatumsData = useMemo(() => VDatums.map((entry: any) => {
    const { text:label, value} = entry;
    return {
      label,
      value
    }
  }), [VDatums]);

  return (
    <BaseForm
      schema={schema}
      render={(methods: any) => (
        <>
        <FieldInputSelect 
                name="timezone" 
                options={TimeZonesData}
                control={methods.control} 
                //defaultValue={timeZone}
                label="Time Zone" 
            />
            
            <FieldInputSelect 
                name="hdatum" 
                options={HDatumsData}
                control={methods.control} 
                defaultValue={selectedHDatum}
                label="Horizontal Datum" 
            />
            
            <FieldInputSelect 
                name="vdatum" 
                options={VDatumsData}
                control={methods.control} 
                defaultValue={selectedVDatum}
                label="Vertical Datum" 
            />
        </>
      )}
    />
  );
}

export default FormCoordinates;